import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const NodeVacancyDetail = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');

  const createdDate = new Date(
    entity.getIn(['created', 0, 'value'])).toLocaleDateString(
    'nl-NL',
    {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    },
  );

  return (
    <article className="NodeVacancyDetail">
      {/* Start of Hero */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2 NodeVacancyDetail__title">
            <h1>{title}</h1>

            <div className="NodeVacancyDetail__body">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>

            <div className="NodeVacancyDetail__created_date">
              {createdDate}
            </div>
          </div>
        </div>
      </Container>


      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="NodeVacancyDetail__paragraphs">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeVacancyDetail;
